import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/cd07971963afdd53018db5f4e5a97aca.png" 
              alt="Picobello Hausservice Logo" 
              className="h-14 w-14 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              Picobello Hausservice
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Startseite
            </Link>
            <Link to="/leistungen" className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Leistungen
            </Link>
            <button onClick={() => scrollToSection('buchung')} className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Buchung
            </button>
            <button onClick={() => scrollToSection('bewertungen')} className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Bewertungen
            </button>
            <button onClick={() => scrollToSection('kontakt')} className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Kontakt
            </button>
            <a href="tel:015758089488" className="bg-orange-500 text-white px-6 py-2.5 rounded-full font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
              Jetzt anrufen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden text-2xl cursor-pointer ${isScrolled ? 'text-gray-900' : 'text-white'}`}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-lg mb-4 py-4">
            <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 font-medium cursor-pointer">
              Startseite
            </Link>
            <Link to="/leistungen" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 font-medium cursor-pointer">
              Leistungen
            </Link>
            <button onClick={() => scrollToSection('buchung')} className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 font-medium cursor-pointer">
              Buchung
            </button>
            <button onClick={() => scrollToSection('bewertungen')} className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 font-medium cursor-pointer">
              Bewertungen
            </button>
            <button onClick={() => scrollToSection('kontakt')} className="block w-full text-left px-6 py-3 text-gray-700 hover:bg-gray-50 font-medium cursor-pointer">
              Kontakt
            </button>
            <div className="px-6 pt-2">
              <a href="tel:015758089488" className="block text-center bg-orange-500 text-white px-6 py-3 rounded-full font-medium hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer">
                Jetzt anrufen
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
